import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/cloud-app/scalable_cloud.webp";

const Androidbuss = () => {
  return (
    <div
      className="androidbuss tekrevol_dark_bg p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={11}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              How TekRevol Ensures High-performing and{" "}
              <span>Scalable Cloud Applications</span>
            </h2>
            <p>
              Our cloud app development company leverages its mature development
              and project management practices, combined with extensive
              multi-domain expertise, to ensure the successful completion of
              cloud app projects. Our approach is designed to address
              uncertainties agilely and deliver high-quality cloud solutions to
              our clients.
            </p>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Predictable Budget</h6>
                <p>
                  We provide transparent budget estimates and proactively
                  suggest cost optimization strategies to ensure accurate
                  planning and budget control.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Simplified Maintenance</h6>
                <p>
                  We provide comprehensive documentation, optimize software
                  architecture, and use tried-and-tested development practices
                  to ensure easy maintenance.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>High Automation</h6>
                <p>
                  With proven experience in DevOps, we automate code
                  integration, testing, and monitoring to deploy frequently with
                  a low failure rate.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Industry-Specific Expertise</h6>
                <p>
                  Our IT consultants and cloud app developers have hands-on
                  experience in diverse industries, allowing them to quickly
                  understand client challenges and create optimal solutions.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Experienced Project Management</h6>
                <p>
                  Our project managers assemble high-performing teams, manage
                  risks, and ensure smooth communication between stakeholders.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Self-Managed Teams</h6>
                <p>
                  Our cross-functional teams are trained to work independently,
                  take full responsibility for quality, and regularly report
                  progress to clients.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
